import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        projects: 'Projects',
        contact: 'Contact',
      },
      common: {
        loading: 'Loading...',
      },
      footer: {
        about: 'About Us',
        aboutText: 'We are dedicated to providing high-quality international services.',
        quickLinks: 'Quick Links',
        legal: 'Legal',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        contact: 'Contact Info',
        address: '123 Business Street, City, Country',
        phone: '+1 234 567 890',
        email: 'contact@example.com',
        copyright: '© 2024 Your Company. All rights reserved.',
        icp: 'ICP License No. XXXXXXXX',
      },
      home: {
        banner: {
          subtitle: 'Welcome to Our Company',
          title: 'Your Global Partner',
          description: 'We provide innovative solutions for international businesses.',
          viewMore: 'View More',
        },
        featuredProjects: {
          title: 'Featured Projects',
          viewAll: 'View All Projects',
        },
      },
      projects: {
        title: 'Our Projects',
        filter: 'Filter Projects',
        viewResults: 'View Results',
        all: 'All Projects',
        viewDetails: 'View Details',
        noResults: 'No projects found in this category.',
      },
      contact: {
        title: 'Shenzhen Dongda International Engineering Design Co., Ltd.',
        address: {
          title: 'Company Address',
          content: 'Room 1601, Beijing Institute of Technology Innovation Building, No. 9 Yuexing Fifth Road, South District of Science and Technology Park, Nanshan District, Shenzhen'
        },
        transportation: {
          title: 'Transportation Guide',
          subway: 'By Subway: Take Line 2 (Shekou Line) to Keyuan Station, Exit D, walk west towards Zhongshan University Building.',
          bus: 'By Bus: Nearby bus stops include "Baidu International Building" and "Keyuan Subway Station".',
          car: 'By Car: Beijing Institute of Technology Innovation Building, No. 9 Yuexing Fifth Road, South District of Science and Technology Park, Nanshan District, Shenzhen.'
        },
        contact: {
          business: 'Business Consultation: +86 (755) 82999545 Lin Chao',
          wechat: 'WeChat Subscription: DDFY001',
          email: 'Email: INFO@ddi-arch.com',
          linkedin: 'LinkedIn: https://www.linkedin.com/company/ddi-arch'
        }
      }
    },
  },
  zh: {
    translation: {
      nav: {
        home: '首页',
        projects: '项目案例',
        contact: '联系我们',
      },
      common: {
        loading: '加载中...',
      },
      footer: {
        about: '关于我们',
        aboutText: '我们致力于提供高品质的国际服务。',
        quickLinks: '快速链接',
        legal: '法律信息',
        privacy: '隐私政策',
        terms: '使用条款',
        contact: '联系方式',
        address: '商务街123号，城市，国家',
        phone: '+1 234 567 890',
        email: 'contact@example.com',
        copyright: '© 2024 您的公司。保留所有权利。',
        icp: 'ICP备案号：XXXXXXXX',
      },
      home: {
        banner: {
          subtitle: '欢迎来到我们公司',
          title: '您的全球合作伙伴',
          description: '我们为国际企业提供创新解决方案。',
          viewMore: '了解更多',
        },
        featuredProjects: {
          title: '重点案例',
          viewAll: '查看所有项目',
        },
      },
      projects: {
        title: '项目案例',
        filter: '筛选项目',
        viewResults: '查看结果',
        all: '全部项目',
        viewDetails: '查看详情',
        noResults: '该类别下没有找到项目。',
      },
      contact: {
        title: '深圳市东大国际工程设计有限公司',
        address: {
          title: '公司地址',
          content: '深圳市南山区科技园南区粤兴五道9号北理工创新大厦1601室'
        },
        transportation: {
          title: '交通指引',
          subway: '搭乘地铁：2号线（蛇口线）科苑站D口出，往西走到中山大学大厦方向。',
          bus: '搭乘公交：附近的公交站点有"百度国际大厦"和"科苑地铁站"',
          car: '自驾：深圳市南山区科技园南区粤兴五道9号北理工创新大厦。'
        },
        contact: {
          business: '商业咨询：+86 (755) 82999545 林超',
          wechat: '微信订阅号：DDFY001',
          email: '电子邮箱：INFO@ddi-arch.com',
          linkedin: 'LINKEDIN: https://www.linkedin.com/company/ddi-arch'
        }
      }
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zh',
    fallbackLng: 'zh',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 
 
